import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalPpiIfs as fetchGlobalAllPpiIfs } from '../../PpiContainer/actions';
import { getfetchingGlobalPpi } from 'features/PpiContainer/selectors';

const useGlobalPublishedPpiIfs = () => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getfetchingGlobalPpi);
  const [globalId, setGlobalId] = useState(null);
  const prevGlobalIdRef = useRef(null);
  const isMounted = useRef(false); // Track if the effect is running for the first time

  const getGlobalId = gID => {
    if (gID && gID !== globalId) {
      setGlobalId(gID); // Update state only if it has changed
    }
  };

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true; // Mark the first render, preventing double API calls
      return;
    }

    if (globalId && prevGlobalIdRef.current !== globalId) {
      dispatch(fetchGlobalAllPpiIfs(globalId));
      prevGlobalIdRef.current = globalId;
    }
  }, [dispatch, globalId]);

  return [isFetching, getGlobalId];
};

export default useGlobalPublishedPpiIfs;
